import Animation from 'src/components/common/animation/index.js';
import { Button, Icon, UncontrolledTooltip } from '@polichat/flamboyant';
interface TranscriptionButtonProps {
  isLoading: boolean;
  error: boolean;
  canTryAgain: boolean;
  handleTranscription: () => void;
  isEnabled: boolean;
}

const DISABLED_MESSAGE =
  'Funcionalidade indisponível. Converse com a nossa equipe para liberar agora mesmo!';

export function TranscriptionButton({
  isLoading,
  error,
  canTryAgain,
  handleTranscription,
  isEnabled,
}: TranscriptionButtonProps) {
  if (isLoading) {
    return (
      <div
        className="transcriptionButton"
        style={{
          width: '40%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          left: '8px',
          bottom: '-17px',
        }}
      >
        <Animation
          style={{ width: '16px', height: '16px', margin: '0 auto' }}
          icon="loading"
        />
        <span style={{ marginLeft: '10px' }}>Transcrevendo...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          width: '34px',
          display: 'flex',
          alignItems: 'center',
          padding: '0 0.25rem',
        }}
      >
        <Button
          color="danger"
          size="sm"
          disabled={!canTryAgain}
          style={{ padding: '0 0.25rem' }}
          onClick={handleTranscription}
        >
          <Icon icon={'poli-icon pi-update-fill'} size={18} />
        </Button>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        left: '8px',
        bottom: '-18px',
      }}
    >
      <Button
        id="transcription-button"
        color="transparent"
        size="sm"
        disabled={!canTryAgain || !isEnabled}
        onClick={handleTranscription}
        className="transcriptionButton"
        style={{
          padding: '0 0.25rem',
          cursor: isEnabled ? 'pointer' : 'not-allowed',
        }}
      >
        {!isEnabled && (
          <UncontrolledTooltip placement="bottom" target="transcription-button">
            {DISABLED_MESSAGE}
          </UncontrolledTooltip>
        )}
        Transcrever
      </Button>
    </div>
  );
}
